import CustomZObject from './CustomZObject.js';
import {MIN_VOLUME, getVolume} from 'engine/pads/Pad.js';

/**
 * Custom object for controling and managing groups within a project
 * This includes the group volumes but also auto-adding tracks to groups
 *
 */
export default class ZGroups extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("group volumes", ([msg]) => this.onLevels(msg));
        this.newOutlet("group volumes ");
        this.newOutlet("group levels");

        this.sequencerEngine.groups.zObject = this;
        this.sequencerEngine.groups.startSendingLevels();
    }

    get groups() {
        return this.sequencerEngine.groups.groups;
    }

    sendLevels() {
        let x = [];
        for (let group of this.groups) {
            if (!group) {
                x.push(0);
            } else {
                let volume = group.volume;
                x.push(volume < MIN_VOLUME ? 0 : Math.pow((volume - MIN_VOLUME)/(1-MIN_VOLUME), window.ROOTY));
            }
        }

        this.sendMessage("group volumes ", x);
    }

    // levels are 0-1 but we probably want them to be volumes
    onLevels(values) {
        console.log('on levels=', values);
        for (let i=0; i < values.length; i++) {
            let val = values[i];
            if (isNaN(val)) {
                continue;
            }
            let slot = this.groups[i];
            if (slot) {
                let vol = getVolume(val, MIN_VOLUME, 1, 1);
                if (slot.volume  !== vol) {
                    console.log("sending %s to group", val, slot, slot.volume);
                    slot.setVolume(vol, false, false);
                }
            }
        }
    }
}
